(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-divot"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.collection-divot').forEach(initCollection);

    function initCollection(section) {
      if (section.dataset.collInit === '1') return;
      section.dataset.collInit = '1';

      const toggle = section.querySelector('[data-collection-filter-toggle]');
      const drawer = section.querySelector('[data-collection-drawer]');
      const scrim = section.querySelector('[data-collection-drawer-scrim]');
      const closeBtn = section.querySelector('[data-collection-drawer-close]');
      const sortSelect = section.querySelector('[data-collection-sort]');
      const sortForm = section.querySelector('[data-collection-sort-form]');

      function openDrawer() {
        drawer?.classList.add('is-open');
        drawer?.setAttribute('aria-hidden', 'false');
        scrim?.classList.add('is-visible');
        toggle?.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }
      function closeDrawer() {
        drawer?.classList.remove('is-open');
        drawer?.setAttribute('aria-hidden', 'true');
        scrim?.classList.remove('is-visible');
        toggle?.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }

      toggle?.addEventListener('click', openDrawer);
      closeBtn?.addEventListener('click', closeDrawer);
      scrim?.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer?.classList.contains('is-open')) closeDrawer();
      });

      // Sort-on-change: rewrite the current URL so other filter params are
      // preserved.
      sortSelect?.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });

      // Load more: AJAX append the next page's grid items.
      const loadMore = section.querySelector('[data-collection-load-more]');
      const grid = section.querySelector('[data-collection-grid]');
      if (loadMore && grid) {
        loadMore.addEventListener('click', async (e) => {
          e.preventDefault();
          loadMore.textContent = 'Loading...';
          try {
            const res = await fetch(loadMore.href, { headers: { 'Accept': 'text/html' } });
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newItems = doc.querySelectorAll('[data-collection-grid] > li');
            newItems.forEach((li) => grid.appendChild(li));
            const newLoadMore = doc.querySelector('[data-collection-load-more]');
            if (newLoadMore) {
              loadMore.href = newLoadMore.href;
              loadMore.textContent = 'Load more';
            } else {
              loadMore.parentElement.remove();
            }
          } catch (err) {
            console.error('Collection load-more failed', err);
            window.location.href = loadMore.href;
          }
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-community-divot"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.comm-divot').forEach(initComm);
    function initComm(section) {
      const track = section.querySelector('[data-comm-track]');
      const prev = section.querySelector('[data-comm-prev]');
      const next = section.querySelector('[data-comm-next]');
      const dots = section.querySelectorAll('[data-comm-dot-index]');
      if (!track) return;

      function slideWidth() {
        const slide = track.firstElementChild;
        if (!slide) return 0;
        const gap = parseFloat(getComputedStyle(track).columnGap || '0') || 16;
        return slide.getBoundingClientRect().width + gap;
      }

      prev?.addEventListener('click', () => track.scrollBy({ left: -slideWidth(), behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left:  slideWidth(), behavior: 'smooth' }));

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const idx = Number(dot.dataset.commDotIndex || 0);
          track.scrollTo({ left: slideWidth() * idx, behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', () => {
        const idx = Math.round(track.scrollLeft / Math.max(slideWidth(), 1));
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
